import { render } from "./SingleSign.vue?vue&type=template&id=ef320cfa&scoped=true"
import script from "./SingleSign.vue?vue&type=script&lang=js"
export * from "./SingleSign.vue?vue&type=script&lang=js"

import "./SingleSign.vue?vue&type=style&index=0&id=ef320cfa&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef320cfa"]])

export default __exports__